import React, { useCallback } from 'react';

import { Select } from 'antd';

import type { SynonymEditHook } from '@/shared/types/editHooks';
import { Button } from '@/shared/ui/Button';

import styles from './SynonymEditPopover.module.css';

export type SynonymEditPopoverProps = {
  synonymEdit: SynonymEditHook;
};

export const SynonymEditPopover: React.FC<SynonymEditPopoverProps> = ({ synonymEdit }) => {
  const { synonyms, isUpdating, hasChanges, handleUpdate, handleClose, handleSynonymsChange } = synonymEdit;

  const sortedSynonyms = React.useMemo(() => {
    return [...synonyms].sort((a, b) => a.localeCompare(b, 'ko-KR'));
  }, [synonyms]);

  const handleSelectChange = useCallback(
    (values: string[]) => {
      const trimmedValues = values.map((v) => v.trim()).filter(Boolean);
      const uniqueValues = Array.from(new Set(trimmedValues));
      handleSynonymsChange(uniqueValues);
    },
    [handleSynonymsChange]
  );

  return (
    <div className={styles.popover}>
      <div className={styles.header}>
        <div className={styles.title}>동의어 편집</div>
      </div>
      <div className={styles.selectContainer}>
        <Select
          mode="tags"
          style={{ width: '100%' }}
          placeholder="동의어를 입력하고 Enter를 누르세요"
          value={sortedSynonyms}
          onChange={handleSelectChange}
          tokenSeparators={[',']}
          disabled={isUpdating}
          maxTagCount="responsive"
        />
      </div>

      <div className={styles.actions}>
        <div className={styles.buttonGroup}>
          <Button variant="outlined" color="standard" onClick={handleClose} disabled={isUpdating}>
            취소
          </Button>
          <Button variant="filled" color="standard" onClick={handleUpdate} loading={isUpdating} disabled={!hasChanges}>
            업데이트
          </Button>
        </div>
      </div>
    </div>
  );
};
